import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Banco de 50 Canciones para el Aula de Música',
    value: '$19',
    image: 'https://cdn.magicpatterns.com/uploads/omMLcNESAiNDj7Wm6BJvWw/Bono_1_musica.webp'
  }, {
    title: 'Guía de Instrumentos Musicales con Materiales Reciclados',
    value: '$27',
    image: 'https://cdn.magicpatterns.com/uploads/fDzKem8UumWp6dDnCewd1v/Bono_2_musica.webp'
  }, {
    title: 'Plantillas de Evaluación Editables para Música',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/6tqubxo1eyTviiF2PDGXBV/Bono_3_musica.webp'
  }, {
    title: 'Rúbricas de Coevaluación entre Alumnos',
    value: '$32',
    image: 'https://cdn.magicpatterns.com/uploads/qF5Aqt2wHKBb8EHZcZykvG/Bono_4_musica.webp'
  }, {
    title: 'Calendario Anual de Música + Planificador de Clases',
    value: '$39',
    image: 'https://cdn.magicpatterns.com/uploads/nWZABxd3XqmWApeezgFD7F/bono_5_musica.webp'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-22">
      <div className="max-w-3xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-25">
            🎁 5 Bonos Exclusivos
          </h2>
          <p className="text-brand-gray" data-id="element-26">
            Valorados en{' '}
            <span className="font-bold text-brand-red line-through" data-id="element-27">
              $85 USD
            </span>{' '}
            — Incluidos <strong className="text-brand-text" data-id="element-28">GRATIS</strong>
          </p>
        </div>

        <div className="space-y-4" data-id="element-29">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl p-4 md:p-6 flex items-center gap-4 md:gap-6 shadow-sm border border-brand-creamDark/50" data-id="element-30">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-gold text-white flex items-center justify-center font-bold shrink-0 text-sm md:text-base" data-id="element-31">
                {i + 1}
              </div>
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden shrink-0 border border-brand-creamDark/50 bg-brand-cream" data-id="element-32">
                <img src={bonus.image} alt={`Portada del bono: ${bonus.title}`} className="w-full h-full object-cover" data-id="element-33" />
              </div>
              <div className="flex-1" data-id="element-34">
                <h3 className="font-bold text-brand-text text-sm md:text-base mb-1" data-id="element-35">
                  {bonus.title}
                </h3>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-36">
                  <span className="text-brand-gray line-through font-medium" data-id="element-37">
                    {bonus.value}
                  </span>
                  <span className="text-brand-red font-bold bg-brand-redLight/50 px-2 py-0.5 rounded text-[10px] tracking-wider uppercase ml-2" data-id="element-38">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}